import { useTranslation } from "react-i18next";
import { Branch, Categories, Chef } from "../types/globalTypes";
import AddCategoryButton from "./Product/AddCategoryButton";
import AddProductButton from "./Product/AddProductButton";

function ProductPageHeader({
  allCategories,
  allBranches,
  setNeedRefetch,
  allChefs,
  productsLength,
}: {
  allCategories: Categories;
  allBranches: Branch[];
  setNeedRefetch: React.Dispatch<React.SetStateAction<boolean>>;
  allChefs: Chef[];
  productsLength: number;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center justify-between gap-2 gap-y-2 sm:gap-y-4">
        {/* Head of page */}

        <div className="flex flex-col md:gap-2">
          <h2 className="col-span-2 py-1 text-2xl capitalize md:col-span-3 md:text-[40px]">
            {t("productHeader.name")}
          </h2>

          <p className="text-bold text-base md:text-xl">
            {t("productHeader.productCount")} :{" "}
            <span className="font-semibold">{productsLength || 0}</span>
          </p>
        </div>

        <div className="flex items-center gap-2">
          <AddProductButton
            allBranches={allBranches}
            allUserCategories={allCategories}
            setNeedRefetch={setNeedRefetch}
          />
          <AddCategoryButton
            allCategories={allCategories}
            allChefs={allChefs}
            setNeedRefetch={setNeedRefetch}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductPageHeader;
